import { lazy, Suspense, useMemo } from "react";
import Meta, { SITE_URL } from "../../components/SEO/Meta";
import { useTranslation } from "react-i18next";

import Hero from "../../components/Layout/Hero/Hero";

const CompanyServices = lazy(() => import("../../components/Layout/CompanyServices/CompanyServices"));
const Technologies    = lazy(() => import("../../components/Layout/Technologies/Technologies"));
const CallToAction    = lazy(() => import("../../components/Layout/CallToAction/CallToAction"));
const Portfolio       = lazy(() => import("../../components/Layout/Portfolio/Portfolio"));
const WhyUs           = lazy(() => import("../../components/Layout/WhyUs/WhyUs"));
const ContactCard     = lazy(() => import("../../components/Layout/ContactCard/ContactCard"));

export default function Home() {
  const { t } = useTranslation();

  const structuredData = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${SITE_URL}/#organization`,
          name: "Softindex",
          alternateName: ["www.softindex.ro", "softindex.ro"],
          url: `${SITE_URL}/`,
          description: t("meta.structuredData.organizationDescription"),
          logo: {
            "@type": "ImageObject",
            url: `${SITE_URL}/og-image.png`,
          },
        },
        {
          "@type": "WebSite",
          "@id": `${SITE_URL}/#website`,
          url: `${SITE_URL}/`,
          name: "Softindex",
          alternateName: "www.softindex.ro",
          description: t("meta.description"),
          publisher: { "@id": `${SITE_URL}/#organization` },
          inLanguage: ["ro-RO", "en-US"],
        },
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/#webpage`,
          url: `${SITE_URL}/`,
          name: t("meta.title"),
          description: t("meta.description"),
          isPartOf: { "@id": `${SITE_URL}/#website` },
          publisher: { "@id": `${SITE_URL}/#organization` },
          inLanguage: ["ro-RO", "en-US"],
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: `${SITE_URL}/og-image.png`,
          },
        },
      ],
    }),
    [t],
  );

  return (
    <div className="app">
      <Meta
        title={t("meta.title")}
        description={t("meta.description")}
        keywords={t("meta.keywords")}
        canonical={`${SITE_URL}/`}
        image={`${SITE_URL}/og-image.png`}
        imageAlt={t("meta.title")}
        siteName="Softindex"
        structuredData={structuredData}
      />

      <main>
        <Hero />

        <Suspense fallback={null}>
          <CompanyServices />
          <Technologies />
        </Suspense>

        <Suspense fallback={null}>
          <CallToAction />
          <Portfolio />
          <WhyUs />
          <ContactCard />
        </Suspense>
      </main>
    </div>
  );
}
